<template>
    <div class="gz-logo">
        <img src="@/assets/imgs/design/logo/logo.png" alt="groozgo.ru" />
    </div>
</template>

<script>
export default {
    name: 'BaseLogo'
}
</script>